/**
 * Domain model enum for setting types
 * Represents available settings pages in the application
 */
export enum SettingType {
  ProfileInfo = 'PROFILE_INFO',
  Password = 'PASSWORD',
  Departments = 'DEPARTMENTS',
  Seniorities = 'SENIORITIES',
  Roles = 'ROLES',
  General = 'GENERAL',
  ExternalRates = 'EXTERNAL_RATES',
  TimeOff = 'TIME_OFF',
  Permissions = 'PERMISSIONS',
  Integrations = 'INTEGRATIONS',
  API = 'API',
  CustomAttributes = 'CUSTOM_ATTRIBUTES',
  Tags = 'TAGS',
  MembersAccess = 'MEMBERS_ACCESS',
}
